import { observer } from 'mobx-react-lite';
import { useRef } from 'react';
import { useMst } from '../../../models/rootModel';
import { useAnalytics } from '../../../utils/analytics';
import { capitalizeFirstLetter } from '../../../utils/utilsFunctions';
import { StepPropsV2 } from './BaseStepV2.types';
import { MainFunnelButtonV2 } from './MainFunnelButtonV2';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';

interface StepV2ConfirmButtonProps extends StepPropsV2 {
  title?: string;
  onClick: () => void;
  isButtonDisabled: boolean;
  isLoading: boolean;
  variant?: MainButtonVariant;
}

export const StepV2ConfirmButton: React.FC<StepV2ConfirmButtonProps> = observer((props) => {
  const { UserDiscoveryResponse, Step } = useMst();
  const analytics = useAnalytics();

  const segmentObject = useRef({
    stepId: props.stepName,
    stepType: props.stepType,
    stepIndex: props.stepIndex,
    stepTitle: props.title,
    ...UserDiscoveryResponse.utms,
    origin: Step.origin,
    userID: UserDiscoveryResponse.accountId,
  });

  const handleOnClick = () => {
    analytics.track(`click onboarding button`, {
      ...segmentObject.current,
    });

    props.onClick();
  };

  return (
    <MainFunnelButtonV2
      onClick={handleOnClick}
      text={props.ctaButtonTitle}
      disabled={props.isButtonDisabled ?? false}
      id={`mainCta_${capitalizeFirstLetter(props.stepType)}`}
      isLoading={props.isLoading}
      variant={props.variant}
    />
  );
});
